import ls from 'local-storage';
import htmlToElement from 'html-to-element';

// const navs = document.querySelectorAll('[data-nav]');
const mainNav = document.querySelector('[data-nav="main"]');
const sectionBtns = document.querySelectorAll('[data-nav-section-btn]');
const locale = mainNav.dataset.navLocale;
const navCachekey = encodeURIComponent(mainNav.dataset.navCachekey);
const savedNavCacheKey = ls('navCachekey') ?? false;
const navLinks = document.querySelectorAll('[data-nav-id][href],[data-nav-id][data-nav-href]');
let mobileNav = null;
let navPages = ls('navPages') ?? {};
let navPagesArray = Object.keys(navPages).map((key) => navPages[key]);

const clearNavPages = (pages) => {
    navPages = {};
    ls('navPages', navPages);
};

const updateNavPages = (id, pages) => {
    // console.log({id, navPages, pages});
    if (!navPages[id]) {
        navPages[id] = {};
    }
    navPages[id].childrenQty = pages.length;
    pages.forEach((page) => {
        navPages[page.id] = page;
    });
    ls('navPages', navPages);
    // console.log({navPages});
    navPagesArray = Object.keys(navPages).map((key) => navPages[key]);
    return pages;
};

const sortPages = (pages) => {
    return pages.sort((a,b) => {
        return parseInt(a.sort) - parseInt(b.sort);
    });
};

const fetchChildren = (id, depth = 0) => {
    const cachekey = encodeURIComponent(mainNav.dataset.navCachekey);
    const fetchURL = `/nav/children/${id}/${locale}.json?m=${cachekey}&depth=${depth}`;
    // console.log({fetchURL});
    return fetch(fetchURL)
        .then(r => r.json())
        .then((data) => {
            if (Array.isArray(data)) {
                // console.log({data});
                const pages = updateNavPages(id, data);
                // console.log({pages});
                return pages;
            }
        })
        .catch((e) => {
            return null;
        });
}


// merge navPages with what's on the page
const mergeNavLinksAndPages = () => {
    navLinks.forEach((link) => {
        const id = parseInt(link.dataset.navId);
        navPages[id] = {
            link: link.href ?? link.dataset.navHref,
            id: link.dataset.navId,
            parentId: link.dataset.navParentId,
            title: link.dataset.navTitle,
            hideFromToolsNav: link.dataset.navHideFromToolsNav,
            childrenQty: link.dataset.navChildrenQty,
            sort: link.dataset.navSort,
            intro: link.dataset.navIntro,
        };
    });
};

const buildNavTree = (parentId = 0) => {
    const tree = [];
    const topLevel = sortPages(navPagesArray.filter((page) => parseInt(page.parentId) === parseInt(parentId)));
    topLevel.forEach((page) => {
        // skip home (unless it has children) {
        if (page.link === '/' && page.childrenQty === 0) {
            return;
        }

        if (parseInt(page.childrenQty) > 0) {
            page.children = buildNavTree(parseInt(page.id));
        }
        tree.push(page);
    });
    return tree;
};

const buildNavHTML = (navTree = []) => {
    const nav = htmlToElement('<ul class="MobileNav__ul"></ul>');
    navTree.forEach((page) => {
        const link = htmlToElement(`<div class="MobileNav__link"><a class="MobileNav__url" href="${page.link}" data-nav-children-qty=${page.childrenQty}>${page.title}</a></div>`);
        const item = htmlToElement(`<li class="MobileNav__li"></li>`);
        item.append(link);
        const qty = parseInt(page.childrenQty);
        if (qty) {
            const drilldown = htmlToElement(`<button class="MobileNav__drilldown -unstyled" type="button" data-nav-drilldown=1 title="Expand"></button>`);
            drilldown.page = page;
            link.append(drilldown);
            if (page.children && page.children.length) {
                const childList = buildNavHTML(page.children);
                item.append(childList);
            }
        }
        nav.append(item);
    });
    return nav;
};

const openBtn = (btn) => {
    const item = btn.closest('li');
    item.classList.add('-open');
    btn.classList.add('-open');
    btn.title = 'Close';
};

const closeBtn = (btn) => {
    const item = btn.closest('li');
    item.classList.remove('-open');
    btn.classList.remove('-open');
    btn.title = 'Expand';
};


const buildNav = (parentId = 0) => {
    const tree = buildNavTree(parentId);
    const nav = buildNavHTML(tree);

    nav.addEventListener('click', (e) => {
        if (e.target.dataset.navDrilldown) {
            const btn = e.target;
            const item = btn.closest('li');
            const ul = item.querySelector('ul');
            e.preventDefault();
            e.stopPropagation();
            const page = e.target.page;
            // console.log(page);
            if (btn.classList.contains('-open')) {
                closeBtn(btn);
            } else {
                if (parseInt(page.childrenQty) > 0 && (!ul || ul.children.length != page.childrenQty)) {
                    btn.classList.add('Loading');
                    fetchChildren(page.id).then((data) => {
                        // console.log({data, navPagesArray});
                        const childTree = buildNavTree(page.id);
                        // console.log({childTree});
                        if (childTree.length) {
                            const childList = buildNavHTML(childTree);
                            // console.log({childList});
                            if (ul) {
                                ul.remove();
                            }
                            item.append(childList);
                            btn.classList.remove('Loading');
                        }
                    });
                }
                openBtn(btn);
            }
        }
    });

    return nav;
};

const setUpMobileNav = (mobileNav) => {
    const path = document.location.pathname;
    mobileNav.classList.add('MobileNav');
    mobileNav.classList.remove('MobileNav__ul');
    const links = mobileNav.querySelectorAll('a');
    links.forEach((link) => {
        const item = link.closest('li');
        const btn = item.querySelector('button');
        if (link) {
            const loc = new URL(link.href).pathname;
            if (path.startsWith(loc)) {
                item.classList.add('-open');
                if (path === loc) {
                    link.classList.add('-current');
                }
                if (btn) {
                    btn.classList.add('-open');
                    btn.title = 'Close';
                }
            }
        }
    });
};

window.closeSubnavs = () => {
    sectionBtns.forEach(btn => btn.classList.remove('-open'));
};

window.addEventListener('click', (e) => {
    const target = e.target;
    if (target && !target.closest('[data-nav]')) {
        window.closeSubnavs();
    }
});

if (navCachekey !== savedNavCacheKey) {
    clearNavPages();
    ls('navCachekey', navCachekey);
}

if (!Object.keys(navPages).length) {
    fetchChildren(0, 2);
}


mergeNavLinksAndPages();


sectionBtns.forEach((btn) => {

    // // hover support
    // const item = btn.closest('li');
    // item.addEventListener('mouseover', () => {
    //     openBtn(btn);
    // });
    // item.addEventListener('mouseout', () => {
    //     closeBtn(btn);
    // });

    // click support
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.classList.contains('-open')) {
            window.closeSubnavs();
        } else {
            window.closeSubnavs();
            openBtn(btn);
        }
    });
});

// mobile nav switch
const mobileToggles = document.querySelectorAll('[data-nav-toggle]');
mobileToggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        console.log({navPages});
        if (!mobileNav) {
            mobileNav = buildNav();
            setUpMobileNav(mobileNav);
            document.querySelector('body').append(mobileNav);
        }
        const body = document.querySelector('body');
        body.classList.toggle('show-mobile-nav');
        return false;
    });
});